import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { T as radioListItem } from './parts.js';
import { d as defineCustomElement$d } from './bank-account-form2.js';
import { d as defineCustomElement$c } from './card-form2.js';
import { d as defineCustomElement$b } from './custom-popper2.js';
import { d as defineCustomElement$a } from './form-control-checkbox2.js';
import { d as defineCustomElement$9 } from './form-control-help-text2.js';
import { d as defineCustomElement$8 } from './form-control-radio2.js';
import { d as defineCustomElement$7 } from './form-control-select2.js';
import { d as defineCustomElement$6 } from './form-control-text2.js';
import { d as defineCustomElement$5 } from './form-control-tooltip2.js';
import { d as defineCustomElement$4 } from './hidden-input2.js';
import { d as defineCustomElement$3 } from './iframe-input2.js';
import { d as defineCustomElement$2 } from './billing-form.js';
import { d as defineCustomElement$1 } from './save-new-payment-method.js';

const PaymentMethodTypeLabels = {
    bankAccount: 'New bank account',
    card: 'New credit or debit card',
};
const NewPaymentMethod = /*@__PURE__*/ proxyCustomElement(class NewPaymentMethod extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.paymentMethodOptionSelected = createEvent(this, "paymentMethodOptionSelected", 7);
        this.saveNewPaymentMethodChecked = false;
        this.onPaymentMethodOptionClick = (e) => {
            e.preventDefault();
            this.paymentMethodOptionSelected.emit(this.paymentMethodOption);
        };
    }
    handleCheckboxChanged(event) {
        this.saveNewPaymentMethodChecked = event.detail;
    }
    async fillBillingForm(fields) {
        this.billingFormRef.fill(fields);
    }
    async resolvePaymentMethod(insuranceValidation) {
        var _a, _b;
        if (!this.paymentMethodFormRef || !this.billingFormRef)
            return;
        try {
            const isValid = await this.validate();
            if (!isValid || !insuranceValidation.isValid) {
                return { validationError: true };
            }
            const tokenizeResponse = await this.tokenize();
            if (tokenizeResponse.error) {
                return { error: tokenizeResponse.error };
            }
            else {
                const tokenizeRessponseData = tokenizeResponse.data;
                return {
                    token: ((_a = tokenizeRessponseData.card) === null || _a === void 0 ? void 0 : _a.token) || ((_b = tokenizeRessponseData.bank_account) === null || _b === void 0 ? void 0 : _b.token),
                    data: tokenizeRessponseData
                };
            }
        }
        catch (error) {
            return { error };
        }
    }
    async validate() {
        const billingFormValidation = await this.billingFormRef.validate();
        const paymentMethodFormValidation = await this.paymentMethodFormRef.validate();
        return billingFormValidation.isValid && paymentMethodFormValidation.isValid;
    }
    async tokenize() {
        try {
            const billingFormFieldValues = await this.billingFormRef.getValues();
            let paymentMethodData;
            if (this.saveNewPaymentMethodChecked) {
                paymentMethodData = Object.assign(Object.assign({}, billingFormFieldValues), { payment_method_group_id: this.paymentMethodGroupId });
            }
            else {
                paymentMethodData = Object.assign({}, billingFormFieldValues);
            }
            const clientId = this.authToken;
            const tokenizeResponse = await this.paymentMethodFormRef.tokenize(clientId, paymentMethodData, this.accountId);
            return tokenizeResponse;
        }
        catch (error) {
            return error;
        }
    }
    showNewPaymentMethodForm() {
        var _a;
        const paymentMethodType = (_a = this.paymentMethodOption) === null || _a === void 0 ? void 0 : _a.id;
        return (h("div", { class: "mt-4 pb-4" }, h("hidden-input", null), paymentMethodType === 'card' ? (h("card-form", { ref: (el) => this.paymentMethodFormRef = el, iframeOrigin: this.iframeOrigin })) : (h("bank-account-form", { ref: (el) => this.paymentMethodFormRef = el, iframeOrigin: this.iframeOrigin })), h("justifi-billing-form", { ref: (el) => (this.billingFormRef = el), hideCardBillingForm: this.hideCardBillingForm, hideBankAccountBillingForm: this.hideBankAccountBillingForm, paymentMethodType: paymentMethodType }), h("justifi-save-new-payment-method", { hidden: !this.paymentMethodGroupId })));
    }
    get hiddenRadioInput() {
        return !this.showAch || !this.showCard;
    }
    render() {
        var _a, _b;
        return (h(Host, { key: 'a3da4a7aa5c5f68bec412be9eb210e8d45d81e80', class: "payment-method" }, h("div", { key: 'b15cf071a206e09333d55d5c7af26b71a79c46cf', class: "radio-list-item p-3", part: radioListItem, onClick: this.onPaymentMethodOptionClick, hidden: this.hiddenRadioInput }, h("form-control-radio", { key: 'd6ff109905c264b201ff3d6f09001a17e4cc351b', name: "paymentMethodType", value: (_a = this.paymentMethodOption) === null || _a === void 0 ? void 0 : _a.id, checked: this.isSelected, label: PaymentMethodTypeLabels[(_b = this.paymentMethodOption) === null || _b === void 0 ? void 0 : _b.id] })), this.isSelected ? this.showNewPaymentMethodForm() : null));
    }
}, [0, "justifi-new-payment-method", {
        "authToken": [1, "auth-token"],
        "accountId": [1, "account-id"],
        "paymentMethodOption": [16, "payment-method-option"],
        "paymentMethodGroupId": [1, "payment-method-group-id"],
        "isSelected": [4, "is-selected"],
        "showCard": [4, "show-card"],
        "showAch": [4, "show-ach"],
        "hideCardBillingForm": [4, "hide-card-billing-form"],
        "hideBankAccountBillingForm": [4, "hide-bank-account-billing-form"],
        "iframeOrigin": [1, "iframe-origin"],
        "saveNewPaymentMethodChecked": [32],
        "fillBillingForm": [64],
        "resolvePaymentMethod": [64],
        "validate": [64]
    }, [[0, "checkboxChanged", "handleCheckboxChanged"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-new-payment-method", "bank-account-form", "card-form", "custom-popper", "form-control-checkbox", "form-control-help-text", "form-control-radio", "form-control-select", "form-control-text", "form-control-tooltip", "hidden-input", "iframe-input", "justifi-billing-form", "justifi-save-new-payment-method"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-new-payment-method":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NewPaymentMethod);
            }
            break;
        case "bank-account-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "card-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "form-control-help-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "form-control-radio":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "hidden-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "iframe-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "justifi-billing-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-save-new-payment-method":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NewPaymentMethod as N, defineCustomElement as d };
